import { Typography, Dialog, DialogContent, DialogActions, Button } from "@mui/material";
import { useState } from "react";
import { storage } from '../../firebaseConfig';  // Import Firebase storage
import { ref, uploadBytes, getDownloadURL } from "firebase/storage"; // Import Firebase Storage functions
import axios from "axios";
import { constants } from "../../Helpers/constantsFile";
import { useSelector } from "react-redux";

export default function UploadLogo({ id, open, handleClose }) {
  const [imageUrl, setImageUrl] = useState("");
  const [height, setHeight] = useState(100);
  const [width, setWidth] = useState(100);
  const [disabled, setDisabled] = useState(true)
  const token = useSelector((state) => state.token.token);


  // Function to upload image and get the download URL
  const uploadImageToFirebase = async (imageFile) => {
    try {
      // Create a reference for the file in Firebase Storage
      const storageRef = ref(storage, `0000logo/${imageFile.name}`);

      // Upload the file to the specified reference
      const uploadTaskSnapshot = await uploadBytes(storageRef, imageFile);

      // Get the download URL after the upload is complete
      const downloadURL = await getDownloadURL(uploadTaskSnapshot.ref);

      alert("Image uploaded successfully!");
      return downloadURL;
    } catch (error) {
      console.error('Error uploading image:', error);
      throw error;
    }
  };

  const handleImageUpload = async (imageFile) => {
    try {
      const imageUrl = await uploadImageToFirebase(imageFile);
      setImageUrl(imageUrl);
      setDisabled(false)
      console.log('Image URL:', imageUrl);
      // Save imageUrl to MongoDB or use it in your app
    } catch (error) {
      console.error('Failed to upload image:', error);
    }
  };

  // Call this function when user selects an image
  const onSelectImage = (event) => {
    const imageFile = event.target.files[0];  // Get the image file from file input
    if (imageFile) {
      handleImageUpload(imageFile);
    }
  };

  const updateUserFun = () => {
    console.log(id);
            axios
          .patch(`${constants.baseUrl}/users/${id}`, {logoUrl: imageUrl}, {
            headers: {
              authorization: token,
            },
          })
          .then((res) => {
            alert("Successfully Updated");
            handleClose();
          })
          .catch((err) => {
            console.log(err)
            alert(err.response?.data?.message);
          });
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogContent>
        <div style={{
          display: "flex",
          flexDirection: "column",
          gap: "30px",
          alignItems: "center"
        }}>
          <input type="file" onChange={onSelectImage} />
          <img
            src={imageUrl}
            alt={`logo`}
            style={{
              width: `${width}px`,
              height: `${height}px`,
              objectFit: "fit",
              borderRadius: "4px",
              border: "2px solid green"
            }}
          />
          <input 
            type="number" 
            value={height} 
            onChange={(e) => setHeight(e.target.value)} 
            placeholder="Height" 
            style={{ height: "40px", width: "150px" }} 
          />
          <input 
            type="number" 
            value={width} 
            onChange={(e) => setWidth(e.target.value)} 
            placeholder="Width" 
            style={{ height: "40px", width: "150px" }} 
          />
        </div>
      </DialogContent>
      <DialogActions>
        <Button 
         disabled = {disabled}
          variant="contained" 
          onClick={updateUserFun} 
          style={{ background: disabled ? "grey" : "#03656F", color: "white" }}>
          Update User
        </Button>
        <Button onClick={handleClose} color="secondary">Cancel</Button>
      </DialogActions>
    </Dialog>
  );
}
